import React, { useEffect } from 'react';

const Product3 = () => {

  const images = [
    "https://www.nano-trend.com/web/upload/201901191558353LFFXPZ.jpg",
    "https://www.nano-trend.com/web/upload/20181217132157EqxB3up.JPG", // Replace with actual paths
    "https://www.nano-trend.com/web/upload/20181219140340BxCL9jS.jpg",
    "https://www.nano-trend.com/web/upload/20181219140724CjCJzTz.jpg",
    "https://www.nano-trend.com/web/upload/20190520092753MAdc5Kn.jpg",
  ];


  useEffect(() => {
    // Scroll to the top of the page when the component is mounted
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-10 bg-black text-white">
      {/* Company Name at the Top */}
      <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black animate-slide-in">
        Nano-Trend Technology Co., Ltd.
      </h1>

      <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black animate-slide-in leading-snug">
        Nano-Trend Technology
      </h1>

      <div className="space-y-12">
        {/* Company Overview Section */}
        <section className="flex flex-col lg:flex-row items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://www.nano-trend.com/web/upload/20211215181630tWaVAwE.png"
              alt="Company Overview"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Company Overview
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              Nano-Trend Technology Co., Ltd. was founded in 2001 with a focus on the Taiwanese Plastic Extrusion Industry. The company developed the "Online Thickness Measurement System," which is now sold globally. With a solid foundation and an innovative R&D team, Nano-Trend has expanded into multiple industries such as Plastics and Rubber, Metal, Paper, PCB, Battery, and Semiconductor, offering high-precision and innovative measurement and automation solutions.
            </p>
          </div>
        </section>

        {/* Products Section */}
        <section className="text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Our Products
          </h3>
          <ul className="list-disc list-inside text-lg space-y-4 transition-all duration-300 hover:text-gray-300">
            <li><strong>Non-Contact Online Thickness Measurement System:</strong> Sheet, film, and board extrusion thickness measurement system</li>
            <li><strong>Blow Film Thickness Measurement System:</strong> System for measuring the thickness of blow films</li>
            <li><strong>Web Inspection System:</strong> Vision defect detection system</li>
            <li><strong>3D Measurement System:</strong> 3D precision profile scan measurement system</li>
            <li><strong>Customized Measurement System:</strong> Systems tailored for specific industries such as hard disk metal stamping parts, CCL thickness measurement, and iron steel sheet thickness measurement</li>
            <li><strong>Robot Application:</strong> 2D and 3D vision systems integrated with robots for automation</li>
          </ul>
        </section>
 {/* Image Section with Hover Animation */}
 <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
          <h3 className="text-3xl font-semibold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-black text-center">
            Our Technology in Action
          </h3>
          {images.map((image, index) => (
            <div
              key={index}
              className="relative group rounded-lg overflow-hidden"
            >
              <img
                src={image}
                alt={`Technology ${index + 1}`}
                className="w-400 h-400 transform transition duration-500 group-hover:scale-110 group-hover:opacity-80"
              />
              <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-xl font-semibold"></span>
              </div>
            </div>
          ))}
        </section>

        {/* Contact Us Section */}
        <section className="mt-12 text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Contact Us
          </h3>
          <p className="text-lg">
            For more information about our products and services, please contact us at:- 
            <a href="mailto: rambomble@alphaq.co.in" className="text-blue-500 hover:text-blue-700 transition-colors duration-300">
            rambomble@alphaq.co.in
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Product3;
